import CalendarMoneyColor from './CalendarMoneyColour.svg';
import CalendarMoneyDark from './CalendarMoneyDark.svg';
import CalendarMoneyLight from './CalendarMoneyLight.svg';
export const calendarMoney = { color: CalendarMoneyColor, dark: CalendarMoneyDark, light: CalendarMoneyLight };
//# sourceMappingURL=index.js.map